export const AUTH_COOKIE_NAME = "atech_access_token";

/** Roll cookie / cookie refresh (rolling sessions). */
export const AUTH_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24;

/** Multi-tenant: sent on every API request when tenant is known. */
export const TENANT_HEADER = "X-Tenant-Id";
